module.exports = __webpack_public_path__ + "static/img/wav-icon.aff7d04.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/wav-icon.png
// module id = 570
// module chunks = 2 7